import { Pipe, PipeTransform } from '@angular/core';

/**
 * Converts an absolute URL to its in-app route path, so [routerLink] opens it on the current
 * admin domain. Notification URLs come from the backend with its own admin domain, which can
 * differ from where the admin is served, and following them directly loses the session.
 */
@Pipe({
    name: 'routePath',
    standalone: false
})
export class RoutePathPipe implements PipeTransform {
  transform(url: string | null | undefined): string | null {
    return url ? new URL(url, window.location.origin).pathname : null;
  }
}
